exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lock {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.lock-icon-show {\n  display: block;\n}\n\n.lock-icon-hide {\n  display: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/js/components/Toggle/Lock/lock.scss
// module id = 187
// module chunks = 0